import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router";
import { verbinde } from "../live/live.ts";
import { useStruktur, type Konto } from "../api/abfragen.ts";
import { Baum } from "../baum/Baum.tsx";
import { EditorSeite } from "../editor/EditorSeite.tsx";
import { Einstellungen } from "../seiten/Einstellungen.tsx";
import { KatalogSeite } from "../seiten/Katalog.tsx";
import { Papierkorb } from "../seiten/Papierkorb.tsx";
import { Todos } from "../seiten/Todos.tsx";
import { PluginUeberblick, WorkspaceUeberblick } from "../seiten/Ueberblick.tsx";
import { Vorlaeufig } from "../seiten/Vorlaeufig.tsx";
import { HinweisBereich, useHinweis } from "../ui/Hinweise.tsx";
import { Kopfleiste } from "./Kopfleiste.tsx";
import { KontoKontext } from "./konto.ts";
import { Schublade } from "./Schublade.tsx";
import "./huelle.css";

function Start() {
  const struktur = useStruktur();
  const erstes = struktur.data?.plugins[0];
  if (erstes) return <Navigate to={`/p/${erstes.schluessel}`} replace />;
  return (
    <main className="zeichenflaeche-leer">
      {struktur.data && <p className="leise">Links ein Plugin anlegen, um zu beginnen.</p>}
    </main>
  );
}

function LiveVerbindung({ kontoId, name }: { kontoId: string; name: string }) {
  const qc = useQueryClient();
  const hinweis = useHinweis();
  useEffect(() => verbinde(qc, { kontoId, name }, (text) => hinweis({ text, art: "fehler" })), [qc, kontoId, name, hinweis]);
  return null;
}

export function Huelle({ konto }: { konto: Konto }) {
  const [baumOffen, setBaumOffen] = useState(false);
  return (
    <KontoKontext.Provider value={konto}>
      <HinweisBereich>
        <LiveVerbindung kontoId={konto.kontoId} name={konto.name} />
        <div className={`huelle${baumOffen ? " baum-offen" : ""}`}>
          <Kopfleiste konto={konto} onMenue={() => setBaumOffen((o) => !o)} />
          <div className="huelle-arbeit">
            <Schublade offen={baumOffen} onSchliessen={() => setBaumOffen(false)}>
              <Baum onNavigiert={() => setBaumOffen(false)} />
            </Schublade>
            <div className="huelle-inhalt">
              <Routes>
                <Route path="/" element={<Start />} />
                <Route path="/p/:plugin" element={<PluginUeberblick />} />
                <Route path="/p/:plugin/:workspace" element={<WorkspaceUeberblick />} />
                <Route path="/p/:plugin/:workspace/:ui" element={<EditorSeite />} />
                <Route path="/katalog/:plugin" element={<KatalogSeite />} />
                <Route path="/todos" element={<Todos />} />
                <Route path="/papierkorb" element={<Papierkorb />} />
                <Route path="/einstellungen" element={<Einstellungen />} />
                <Route path="*" element={<Vorlaeufig titel="Diese Seite gibt es nicht." />} />
              </Routes>
            </div>
          </div>
          <button type="button" className="baum-schleier" aria-label="Struktur schließen" tabIndex={-1} onClick={() => setBaumOffen(false)} />
        </div>
      </HinweisBereich>
    </KontoKontext.Provider>
  );
}
